

import { Button } from "@a2z/ui";

import type { MouseEventHandler } from "react";

type Props = {
  formId?: string;
  cancelLabel: string;
  saveLabel: string;
  loadingLabel?: string;
  onCancel: MouseEventHandler<HTMLButtonElement>;
  isSaving?: boolean;
  saveDisabled?: boolean;
  className?: string;
  hideCancel?: boolean;
  centered?: boolean;
};

export function FormActionButtons({
  formId,
  cancelLabel,
  saveLabel,
  loadingLabel,
  onCancel,
  isSaving = false,
  saveDisabled = false,
  className,
  hideCancel = false,
  centered = false,
}: Props) {
  const direction =
    typeof document !== "undefined" && document.dir === "rtl" ? "rtl" : "ltr";

  const alignClass = centered
    ? "justify-center"
    : direction === "rtl"
      ? "justify-start"
      : "justify-end";

  return (
    <div
      className={`flex flex-wrap items-center gap-3 ${alignClass} ${className ?? ""}`.trim()}
    >
      {!hideCancel ? (
        <Button variant="ghost"
          type="button"
          onClick={onCancel}
          className="h-11 rounded-lg px-4 text-sm font-semibold text-[color:var(--text-secondary)] transition hover:text-[color:var(--text-primary)]"
        >
          {cancelLabel}
        </Button>
      ) : null}
      <Button
        type="submit"
        form={formId}
        disabled={isSaving || saveDisabled}
        variant="primary" className="h-11 rounded-lg px-4 text-sm font-semibold transition disabled:opacity-60 cursor-pointer disabled:cursor-not-allowed"
      >
        {isSaving ? loadingLabel ?? saveLabel : saveLabel}
      </Button>
    </div>
  );
}
